<template>
<div class="document-type-list">
  <table class="tbl tbl--tablet-cards">
    <thead>
      <tr>
        <th width="200">Название</th>
        <th>Активность</th>
        <th>Сортировка</th>
        <th>Время выполнения (мин)</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <item
        v-for="item in documentsData"
        :data="item"
        :urgency-data="urgencyData"
        :key="item.id"
      />
    </tbody>
  </table>
</div>
</template>

<script>
export default {
  components: {
    item: require("./item.vue").default
  },

  props: {
    documentsData: {
      type: Array,
      required: true
    },
    urgencyData: {
      type: Array,
      required: true
    }
  }
};
</script>
